import React from "react";
import "../css/footer.css";
import { ReactComponent as MessageIcon } from "../assets/icons/footer/message.svg";

const Footer = () => {
  return (
    <section id="lp-footer-section">
      <div>
        <section>
          <article>
            <h2>All subjects</h2>
            <p>
              We ara a lorem ipsum dolor sit amet, consectetur adipiscing elit,
              sed do eiusmod.
            </p>
          </article>
          <article>
            <dl id="foot-sub-list">
              <div>
                <dd>General</dd>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Mathematics
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    English language
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Agricultural Science
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Geography
                  </a>
                </dt>
                <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                  See all
                </a>
              </div>
              <div>
                <dd>Science</dd>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Chemistry
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Physics
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Further mathematics
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Biology
                  </a>
                </dt>
                <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                  See all
                </a>
              </div>
              <div>
                <dd>Arts</dd>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Literature in English
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    History
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Fine and Applied Arts
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Music
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Christian Religious Studies
                  </a>
                </dt>
                <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                  See all
                </a>
              </div>
              <div>
                <dd>Commercial</dd>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Economics
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Commerce
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Government
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Principles of Account
                  </a>
                </dt>
                <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                  See all
                </a>
              </div>
              <div>
                <dd>Technical</dd>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Auto Mechanics
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Electronics
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Metal Works
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Welding and Fabrication
                  </a>
                </dt>
                <dt>
                  <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                    Refrigeration and Air conditioning
                  </a>
                </dt>
                <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                  See all
                </a>
              </div>
            </dl>
          </article>
        </section>
        <section>
          <article>
            <h2>Get exam tips</h2>
            <p>
              Be the first one to get email tips and know about discount, offers
              and evemts weekly in your mailbox
            </p>
            <div id="email-sub">
              <MessageIcon id="message-icon" />
              <input
                type="email"
                id="email-sub-input"
                placeholder="Enter your email"
              />
              <button>Submit</button>
            </div>
          </article>
          <nav>
            <ul>
              <li>
                <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                  About us
                </a>
              </li>
              <li>
                <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                  Press
                </a>
              </li>
              <li>
                <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                  FAQ
                </a>
              </li>
              <li>
                <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                  Careers
                </a>
              </li>
              <li>
                <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                  Contact
                </a>
              </li>
              <li>
                <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                  Privacy policy
                </a>
              </li>
              <li>
                <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                  Sitemap
                </a>
              </li>
              <li>
                <a href="" /*eslint-disable-line jsx-a11y/anchor-is-valid*/>
                  Terms of Use
                </a>
              </li>
            </ul>
          </nav>
          <hr id="foot-rule" />
          <div id="copyright">&copy;2000-2021 All Rights Reserved</div>
        </section>
      </div>
    </section>
  );
};

export default Footer;
